import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';
import cn from 'classnames';

const Suggestion = ({
  inputValue,
  label,
  isHighlighted,
  isPressed,
  isSelected,
  renderSuggestionText,
}) => {
  const isInputValue = !!inputValue;
  return (
    <div
      className={cn(styles.dropDownListItem, {
        [styles.highlightedItem]: isHighlighted,
        [styles.activeItem]: isPressed,
        [styles.selectedItem]: isSelected,
      })}
    >
      {!!renderSuggestionText && renderSuggestionText(label, inputValue)}
      {!renderSuggestionText && isInputValue && (
        <>
          <span className={styles.dropDownListItemHighlight}>
            {label.substring(0, inputValue.length)}
          </span>
          {label.substring(inputValue.length)}
        </>
      )}
      {!renderSuggestionText && !isInputValue && (
        <span className={styles.dropDownListItemHighlight}>{label}</span>
      )}
    </div>
  );
};

Suggestion.propTypes = {
  inputValue: PropTypes.string,
  isHighlighted: PropTypes.bool,
  isPressed: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  renderSuggestionText: PropTypes.func,
};

export default Suggestion;
